import { render, staticRenderFns } from "./InquiryDetailPopup.vue?vue&type=template&id=2a6e430b&scoped=true&"
import script from "./InquiryDetailPopup.vue?vue&type=script&lang=ts&"
export * from "./InquiryDetailPopup.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryDetailPopup.vue?vue&type=style&index=0&id=2a6e430b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e430b",
  null
  
)

export default component.exports